// extracted by mini-css-extract-plugin
export default {"iconContainer":"AppetiteIcon_iconContainer__uF9x8","text":"AppetiteIcon_text__BVomp"};